export const DefaultBidCPVWarningThreshold = 0.20;
